var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-options__item",class:{
    'export-options__item--selected': _vm.isSelected,
    'export-options__item--disabled': !_vm.hasConsent
  },on:{"click":_vm.updateSelectedOption}},[_c('img',{staticClass:"mr-2",attrs:{"height":"24","width":"24","src":_vm.$images.CONNECTOR_LOGO(_vm.sourceId)}}),_c('span',[_vm._v(_vm._s(_vm.sourceName))])])}
var staticRenderFns = []

export { render, staticRenderFns }